export const CIBuildNumber = FEbuild;
export const CIBuildDate = CIbuildTimeStamp;
// eslint-disable-next-line no-undef
export const CIBuildFeatures = FEbuildFeatures;

export const DatabasesLinksMap = {
  'Reaxys Medicinal Chemistry': 'MedChem', // If can't find database link by name, use that map
};
export const Licenses = {
  Reaxys: 'Reaxys:Reaxys',
  ReaxysMedChem: 'Reaxys:ReaxysMedChem',
  Both: 'Reaxys:Both',
};

export const Events = {
  // ? NOT USED
  search: 'searchInProgress',
  elementFlagsUpdated: 'elementFlagsUpdated',
};
export const GizmoIcons = {
  // NOT USED ?
  welcome: 'ss-login i-top4',
  search: 'ss-search',
  buildquery: 'ss-search',
  properties: 'ss-database',
  overview: 'ss-view',
  results: 'ss-properties i-top6 transparent',
  quickresults: 'ss-crosshair',
  fullDetails: 'ss-navigateleft',
};
export const SearchTypes = {
  QUICK_SEARCH: 'quick',
  ADVANCED_SEARCH: 'advanced',
  SIMILARITY_SEARCH: 'similarity',
  DOCUMENT_SEARCH: 'document',
  SUBSTANCE_SEARCH: 'substance',
  TARGET_SEARCH: 'target',
  MARKUSH_SEARCH: 'markush',
  BATCH_SEARCH: 'batch',
  MANUALLY_FILTERED: 'manually',
  CROSS_LINKING: 'cross',
  MARKUSH_SUBSTANCES: 'relatedMarkush',
  MANUAL_SYNTHESIS: 'manualSynthesis',
};

export const RxSocketUrls = {
  Filters: {
    Group: '/app/filters/group',
    GroupResult: '/user/filters/group/result',
    SearchFilter: '/app/search/filter',
    SearchLimit: '/app/search/limit',
  },
  ConnectionUrl: '/ws?access_token=',
  QuickSearchUrl: '/app/search/quick',
  SearchInfo: '/app/search/rxid',
  AdvancedQuery: '/app/search/advanced',
  BatchQuery: '/app/search/batch',
  ResultsUrl: '/app/results',
  SwitchContext: '/app/results/smart/switch',
  SimilarReactions: '/app/similarity/reaction',
  SimilarSubstance: '/app/similarity/substance',
  SimilarSubstanceAdvanced: '/app/similarity/substance/advanced',
  SimilarSynthesize: '/app/similarity/synthesize',
  SessionInfo: {
    Request: '/app/echo/ping',
    Response: '/user/echo/pong',
  },
  ChannelsUrls: {
    ProgressInfo: '/user/progress/info',
    SearchInfo: '/user/search/info',
    CoHitsets: '/user/results/cohitsets',
    ResultsInfo: '/user/results/info',
    BatchResultsInfo: '/user/search/batch/info',
    QueueErrors: '/user/queue/errors',
    ResultsCustom: '/user/results/custom',
    Heartbeat: '/app/heartbeat',
    heatmap: {
      create: '/app/heatmap/create',
      info: '/user/heatmap/info',
      retreive: '/app/heatmap/retrieve',
      detailsList: '/app/heatmap/details/list',
    },
    gsfn: {
      create: '/app/gsfn/create',
      result: '/user/gsfn/result',
    },
    planner: {
      custom: '/user/planner/custom',
    },
    ReEncryption: {
      subscribe: '/app/retrosynthesis/user/encryption',
      status: '/user/retrosynthesis/encryption/status',
    },
  },
  Export: {
    output: '/app/output',
    info: '/user/output/info',
    result: '/user/output/result',
    cancel: '/app/output/cancel/{jobId}',
    restore: '/app/output/restore/{jobId}',
  },
  ExportChemQuote: {
    output: '/app/output/chemquote',
    cancel: '/app/output/chemquote/cancel/{jobId}',
  },
  CancelSearch: '/app/search/cancel/{searchId}',
  CancelQuery: '/app/search/query/cancel/{queryId}',
  RestoreQuery: '/app/search/query/restore/{queryId}',
  RestoreResult: '/app/search/restore/{resultName}',
  ManualSynthesis: '/app/planner/synthesize',
  HeatmapThumbnail: {
    input: '/app/heatmap/thumbnail',
    output: '/user/heatmap/thumbnail',
  },
  RetroSynthesis: {
    PublishedProjectsStatusesSend: '/app/retrosynthesis/projects/overview',
    PublishedProjectsStatusesSubscribe: '/user/retrosynthesis/projects/status',
    PredictedProjectsStatusesSend: '/app/retrosynthesis/projects/jobs',
    PredictedProjectsStatusesSubscribe: '/user/retrosynthesis/projects/job/status',
  },
};

export const socketConfig = {
  RETRY_LIMIT: 2,
  TIMEOUT: 30000,
  DELAY: 250,
  REASON_RETRY: 'retry',
  REASON_LIMIT: 'retryLimit',
  REASON_CANCEL: 'cancel',
  REASON_CLEANUP: 'cleanup',
  REASON_STOP: 'stop',
  // RX-1968 - do not resend search request for QS, Query builder and filters
  PREVENT_RETRY_SEND: [
    // QS is handled separately in quick-results.controller.js
    RxSocketUrls.AdvancedQuery,
    RxSocketUrls.Filters.SearchFilter,
  ],
  ON_DISCONNECT_MODAL: {
    error: 'The Server encountered a temporary issue and could not complete your request',
    text: `The Server encountered a temporary issue and could not complete your request. This happens sometimes and we are working on fixing this.
In a few minutes please try your last action again, after either refreshing the page or clearing your cache. `,
    title: 'Server connection interrupted',
    type: 'error',
    size: 'md',
    confirmText: 'OK',
  },
};
export const messageBrokerConfig = {
  CONNECTION_LIMIT: 3,
  RETRY_LIMIT: 3,
  RETRY_DELAYS: [1000, 2000],
  STATUS: {
    PENDING: 'pending',
    FINISHED: 'finished',
    LIMIT_REACHED: 'retryLimitReached',
    ABORT: 'abort',
  },
  repeatableStatusCodes: [-1, 502, 503, 504, 507, 520, 523, 524, 525],
};

export const storedSettings = {
  query: {
    name: 'storedQuery',
    key: 'query',
  },
  searchKeys: ['fact', 'form', 'field'],
  basicDatabase: 0,
  contextTypes: ['citations', 'substances', 'reactions'],
  fieldKey: 'field',
  settingsForPropertiesTree: {
    hiddenList: [],
  },
  search: {
    name: 'storedSearch',
    key: 'searching',
  },
  searchBuilder: {
    name: 'searchBuilder',
    key: 'selectedProperties',
  },
  filters: {
    name: 'filtersState',
    key: 'filtersValues',
  },
  currentContexts: {
    name: 'storedContexts',
    key: 'contexts',
  },
};

export const marketingUrl = 'https://www.elsevier.com/solutions/reaxys?dgcid=RN_AGCM_Sourced_300005028';
export const helpUrl = 'https://service.elsevier.com/app/home/supporthub/reaxys';
export const salesUrl = 'https://www.elsevier.com/solutions/reaxys/contact-sales?dgcid=RN_AGCM_Sourced_300005027';
export const betaConfig = {
  /* these are default values (const), toggles are set in user profile */
  disabled: {
    historyAlert: true,
  },
  hidden: {
    queryBuilderFavouriteButton: true,
    queryBuilderLookupSorting: true,
    queryBuilderFormHeader: true,
  },
};
export const loginTypes = {
  INSTITUTION: 'institution',
  SIMPLE: 'simple',
};

export const KEYCODES = {
  TAB: 9,
  ESC: 27,
  SPACE: 32,
  ENTER: 13,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
};
export const UsabillaLicenses = {
  Reaxys: 'rxonly',
  ReaxysMedChem: 'medonly',
  Both: 'combined',
  None: 'none',
};
export const RXTopics = {
  batchSearch: {
    all: 'BATCH_SEARCH',
    searchStarted: 'BATCH_SEARCH:search_started',
    singleQueryStarted: 'BATCH_SEARCH:singleQueryStarted',
    singleQueryProcessed: 'BATCH_SEARCH:singleQueryProcessed',
    databaseStarted: 'BATCH_SEARCH:database_started',
    databaseSkipped: 'BATCH_SEARCH:database_skipped',
    databaseProcessed: 'BATCH_SEARCH:database_processed',
  },
};

export const DEFAULT_HEARTBEAT_INTERVAL = 60 * 5; // 5 mins
export const DEFAULT_HEARTBEAT_FAIL_INTERVAL = 2 * DEFAULT_HEARTBEAT_INTERVAL;

export const idleTiming = {
  USER_ACTION_CHECK_INTERVAL: 1000,
  NOTIFICATION_TIMEOUT: 60000 * 5,
};
